import axios from "axios";
import axiosInstance from "./axiosInstance";

const apiUrl = process.env.REACT_APP_API_URL;

export async function getCustomerCount() {
  try {
    const response = await axiosInstance.get(`${apiUrl}/api/get_customer/`);

    const customers = response.data.data;

    return customers.length;
  } catch (error) {
    console.error("Error fetching customer data:", error);
    return 0;
  }
}

// Get Developer Count
export async function getDeveloperCount() {
  try {
    const response = await axiosInstance.get(`${apiUrl}/api/get_all_users/`);

    // assuming same structure as customer API
    return response.data?.data?.length || 0;
  } catch (error) {
    console.error("Error fetching developer data:", error);
    return 0;
  }
}

// Get Projects Count
export async function getProjectCount() {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/api/ticket_subcategories/`,
    );

    return response.data?.data?.length || 0; // return count of projects
  } catch (error) {
    console.error("Error fetching projects data:", error);
    return 0;
  }
}

//API to get Ticket Status Summary :
export async function getTicketStatusSummary(companyId) {
  const response = await axiosInstance.get(
    `${apiUrl}/api/tickets/status-summary/?company_id=${companyId}`,
  );
  return response;
}

// API to get Ticket Status Summary By Date
export async function getTicketStatusSummaryByDate(
  companyId,
  from_date,
  to_date,
) {
  const response = await axiosInstance.get(
    `${apiUrl}/api/tickets/status-summary-by-date/`,
    {
      params: {
        company_id: companyId,
        from_date: from_date,
        to_date: to_date,
      },
    },
  );

  return response;
}

// Get Contact Counts for Customers
export async function getContactForCust() {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/api/customer-contact/list/`,
    );

    return response?.data;
  } catch (error) {
    console.error("Error fetching customer data:", error);
    return 0;
  }
}

// Get Projects Counts for Customers
export async function getProjectForCust(custCode) {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/api/customer/project-count/${custCode}/`,
    );
    // console.log("Response Data : ", response?.data);
    return response?.data;
  } catch (error) {
    console.error("Error fetching projects data:", error);
    return 0;
  }
}

//API to get Customer Ticket Status Summary :
export async function getCustTicketStatusSummary(customerID) {
  const response = await axiosInstance.get(
    `${apiUrl}/api/customer/dashboard/status-summary/?customer_id=${customerID}`,
  );
  return response;
}

// API to get Customer Ticket Status Summary By Date
export async function getCustTicketStatusSummaryByDate(
  customerId,
  from_date,
  to_date,
) {
  const response = await axiosInstance.get(
    `${apiUrl}/api/customer/dashboard/status-summary-by-date/`,
    {
      params: {
        customer_id: customerId,
        from_date: from_date,
        to_date: to_date,
        // format: YYYY-MM-DD
      },
    },
  );

  return response;
}

//get count of project, assigned and resolved tickets for developers
export async function getUserProjectMapping(companyId, userId) {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/api/user-project-mapping/?company_id=${companyId}&user_id=${userId}`,
    );

    // console.log("User Project Mapping Response:", response?.data);

    return response?.data;
  } catch (error) {
    console.error("Error fetching user project mapping:", error);
    return null;
  }
}

//API to get Developer Ticket Status Summary :
export async function getUserTicketStatusSummary(companyId, userId) {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/api/user-ticket-status-summary/?company_id=${companyId}&user_id=${userId}`,
    );

    // console.log("User Ticket Summary:", response?.data);

    return response?.data;
  } catch (error) {
    console.error("Error fetching ticket summary:", error);
    return null;
  }
}

//API to get Developer Ticket Status Summary By Date
export async function getUserTicketStatusSummaryByDate(
  companyId,
  userId,
  fromDate,
  toDate,
) {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/api/user-ticket-status-summary-by-date/?company_id=${companyId}&user_id=${userId}&from_date=${fromDate}&to_date=${toDate}`,
    );

    // console.log("User Ticket Summary By Date:", response?.data);

    return response?.data;
  } catch (error) {
    console.error("Error fetching date-wise ticket summary:", error);
    return null;
  }
}

// API to get Contact Ticket Status Summary :
export async function getContactTicketStatusSummary() {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/api/contact-ticket-status-summary/`,
    );

    // console.log("Contact Ticket Summary:", response?.data);

    return response?.data;
  } catch (error) {
    console.error("Error fetching contact ticket summary:", error);
    return null;
  }
}

// API to get Contact Ticket Status Summary By Date
export async function getContactTicketStatusSummaryByDate(fromDate, toDate) {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/api/contact-ticket-status-summary-by-date/?from_date=${fromDate}&to_date=${toDate}`,
    );

    // console.log("Contact Ticket Summary By Date:", response?.data);

    return response?.data;
  } catch (error) {
    console.error("Error fetching contact ticket summary by date:", error);
    return null;
  }
}
